import {
  AUDIT_CLEAR,
  AUDIT_GET,
  AUDIT_GET_ACTION_TYPES,
  AUDIT_GET_DETALLE,
} from "../actions/audit";

const vacio = {
  isFetching: false,
  didInvalidate: false,
  data: [],
};

const INITIAL_STATE = {
  consulta: { ...vacio },
  actionTypes: { ...vacio },
  detalle: {
    isFetching: false,
    didInvalidate: false,
    data: null,
  },
};

const audit = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${AUDIT_GET}_PENDING`:
      return { ...state, consulta: { ...state.consulta, isFetching: true, didInvalidate: false } };
    case `${AUDIT_GET}_FULFILLED`:
      return {
        ...state,
        consulta: { isFetching: false, didInvalidate: false, data: action.payload.data || [] },
      };
    case `${AUDIT_GET}_REJECTED`:
      return { ...state, consulta: { ...state.consulta, isFetching: false, didInvalidate: true } };
    case `${AUDIT_GET_ACTION_TYPES}_PENDING`:
      return { ...state, actionTypes: { ...state.actionTypes, isFetching: true, didInvalidate: false } };
    case `${AUDIT_GET_ACTION_TYPES}_FULFILLED`:
      return {
        ...state,
        actionTypes: { isFetching: false, didInvalidate: false, data: action.payload.data || [] },
      };
    case `${AUDIT_GET_ACTION_TYPES}_REJECTED`:
      return { ...state, actionTypes: { ...state.actionTypes, isFetching: false, didInvalidate: true } };
    case `${AUDIT_GET_DETALLE}_PENDING`:
      return { ...state, detalle: { ...state.detalle, isFetching: true, didInvalidate: false } };
    case `${AUDIT_GET_DETALLE}_FULFILLED`:
      return {
        ...state,
        detalle: { isFetching: false, didInvalidate: false, data: action.payload.data || null },
      };
    case `${AUDIT_GET_DETALLE}_REJECTED`:
      return { ...state, detalle: { isFetching: false, didInvalidate: true, data: null } };
    case AUDIT_CLEAR:
      return { ...state, consulta: { ...vacio }, detalle: { isFetching: false, didInvalidate: false, data: null } };
    default:
      return state;
  }
};

export default audit;
